import { useLocation, Navigate, Outlet, useNavigate } from "react-router-dom";
import { getLocalStorage } from "../utils/localStorage";
import { Navbar, Sidebar, UserProfile } from "../components";
import { useStateContext } from "../contexts/ContextProvider";
import lockImg from "./../data/lock.png";
import { useEffect } from "react";
import { HiMenuAlt1, HiOutlineChevronDoubleRight } from "react-icons/hi";
import { Fab } from "@mui/material";
import { AddIcCallOutlined } from "@mui/icons-material";
import { FaUserCircle } from "react-icons/fa";
const RestrictedPage = () => {
    const navigate = useNavigate();
    useEffect(() => {
        setTimeout(() => {
            navigate(-1)
        }, 2000);
    }, [])

    return (<>
        <div className="restrcited-page" >
            <div className="restrcited-page-inner">
                <div className="restrcited-page-img" >
                    <img src={lockImg} style={{ height: 125, width: 125 }} alt="restrictedpage" />
                </div>
                <p className="restrcited-page-p">You don't have permission to view this page</p>
            </div>
        </div>
    </>)
}

const RequireAuth = ({ allowedRoles }) => {
    const is_Authorized = getLocalStorage("USER_AUTH")
    const { role, orgId } = getLocalStorage("CURRENT_USER") ?? [] 
    const location = useLocation();
    const { activeMenu, setActiveMenu, setIsClicked, screenSize, setScreenSize, isClicked, handleClick } = useStateContext();

    // Check if the route requires orgId
    const requiresOrgId = (location.pathname.includes("/home/addUser" || location.pathname.includes("/home/myOrganization")));
    const hasOrgIdAccess = requiresOrgId ? orgId : true;

    useEffect(() => {
        const handleResize = () => setScreenSize(window.innerWidth);
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, [screenSize]);
    useEffect(() => {
        if (screenSize <= 900) {
            setActiveMenu(false);
        } else { setActiveMenu(true) }
    }, [screenSize])
    return (
        is_Authorized ?
            <>
                {
                    screenSize >= 1000
                        ?
                        <>
                            <div style={{ background: "rgb(244, 249, 253)" }} className='flex relative'>
                                <div style={{
                                    //  background: "#fff",
                                    background: "#f4f9fd",
                                    padding: 10
                                }} className={` side-bar fixed ${activeMenu ? 'w-64 sidebar ' : screenSize <= 900 ? "w-0" : " w-14 sidebar "}`}>
                                    <Sidebar />
                                </div>
                                <div style={{ overflow: "hidden", background: "rgb(244, 249, 253)" }} className={`dark:bg-main-bg bg-main-bg min-h-screen w-full ${activeMenu ? " md:ml-64" : screenSize <= 900 ? "" : "md:ml-14"}`}>
                                    {role && role.find(r => allowedRoles.includes(r)) && hasOrgIdAccess
                                        ? <Outlet />
                                        : <RestrictedPage />
                                    }
                                </div>
                            </div >
                        </>
                        :
                        <>
                            <div style={{ background: "rgb(244, 249, 253)" }}>
                                <Sidebar />
                                <div style={{ overflow: "hidden", background: "rgb(244, 249, 253)" }} className={`dark:bg-main-bg bg-main-bg min-h-screen w-full pt-16`}>
                                    {role && role.find(r => allowedRoles.includes(r)) && hasOrgIdAccess
                                        ? <Outlet />
                                        : <RestrictedPage />
                                    }
                                </div>
                            </div>
                        </>
                }
            </>
            :
            <Navigate to="/login" state={{ from: location }} replace />
    )


}

export default RequireAuth;